import React from "react";
import MoviesTopRated from "./components/MoviesTopRated";
import Navbar from "./components/Navbar";
import Pagination from "./components/Pagination";
import Upcoming from "./components/Upcoming";
import Hero from "./pages/Hero";
import Movies from "./pages/Movies";
function App() {
  return (
    <div className="">
      <Navbar />
      <Hero />
      <MoviesTopRated />
      <Movies />
      <Upcoming />
    </div>
  );
}

export default App;
